import React, { useEffect, useState } from "react";
import { saveAs } from 'file-saver';

import Buttons from "../../../../../../components/ui/button/Buttons";
import FormDatePickerFields from "../../../../../../components/finalForms/formFields/FormDatePickerField";

import { useExportContractMonthlyRevenueReportMutation } from "../../../../../../app/services/contractAPI";
import { format_Date } from "../../../../../../components/finalMolGrid/libs/formatDate";

const MonthlyRevenue = (props) => {

  const [isMonth, setIsMonth] = useState( new Date(new Date().getFullYear(), new Date().getMonth(), 1));

  const [contractMonthlyRevenueReport, {
    isLoading: isExporting,
    isSuccess: isAllExported,
    data: exportAllData
  }] = useExportContractMonthlyRevenueReportMutation();

  useEffect(() => {
    if (!isExporting && isAllExported && exportAllData) {
      const blob = new Blob([exportAllData]);
      saveAs(blob, `Contracts Monthly Revenue Report${props.currentDate}.xlsx`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExporting, isAllExported, exportAllData]);

  const handalExportCovered = () => {
    
    contractMonthlyRevenueReport({ pdtMonth: format_Date(isMonth) });
  }
  const handleClear = () => {
    setIsMonth("");
  }

  return (
    <div className="row p-2">
      <div className="col-7">
        <FormDatePickerFields
          dataField="pdtMonth"
          value={isMonth}
          labelName="Select Month"
          isRequired={true}
          type="month"
          name="Select Month"
          fieldSetting={{
            dateConfig: {
              displayMonthPicker: true,
              format: "MMMM yyyy"
            }
          }}
          onChange={(dataField, value) => setIsMonth(value)}
        />
      </div>
      <div className="col-5">
        <div className="d-flex justify-content-center button-submit mb-2">
          <Buttons
            buttonText="Extract"
            buttonTypeClassName="btn blue-btn w-full"
            onClick={handalExportCovered}
          />
          <Buttons
            buttonText="Clear"
            buttonTypeClassName="btn secondary-btn ml-4"
            onClick={handleClear}
          />
        </div>
      </div>
    </div>
  );
};

export default MonthlyRevenue;
